import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=d94c48e4&scoped=true&"
import script from "./agreement.vue?vue&type=script&lang=js&"
export * from "./agreement.vue?vue&type=script&lang=js&"
import style0 from "./agreement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./agreement.vue?vue&type=style&index=1&id=d94c48e4&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d94c48e4",
  null
  
)

export default component.exports